export default __webpack_public_path__ + "static/media/closet5-before2-480w.5fd311ed.webp";